"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { GalleryMediaItem, useMediaGallery } from "..";
interface GalleryDotsProps {
  className?: string;
  maxVisibleDots?: number;
}
export function GalleryDots(t0) {
  const $ = _c(26);
  const {
    className,
    maxVisibleDots: t1
  } = t0;
  const maxVisibleDots = t1 === undefined ? 7 : t1;
  const {
    currentIndex,
    media,
    goToIndex
  } = useMediaGallery();
  const totalMedia = media.length;
  const center = Math.floor(maxVisibleDots / 2);
  if (totalMedia <= 1) {
    return null;
  }
  let t2;
  if ($[0] !== className) {
    t2 = cn("absolute bottom-12 left-1/2 transform -translate-x-1/2 flex items-center", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      overflow: "hidden"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  bb0: {
    if (totalMedia <= maxVisibleDots) {
      let t5;
      if ($[3] !== currentIndex || $[4] !== goToIndex || $[5] !== media) {
        let t6;
        if ($[7] !== currentIndex || $[8] !== goToIndex) {
          t6 = (_, index) => <div key={index} role="button" tabIndex={0} className={cn("rounded-full transition-all duration-300 cursor-pointer outline-none", index === currentIndex ? "w-3 h-3 bg-white" : "w-2 h-2 bg-white/60 hover:bg-white/80")} onMouseDown={_temp} onClick={e_0 => {
            e_0.preventDefault();
            e_0.stopPropagation();
            e_0.nativeEvent.stopImmediatePropagation();
            goToIndex(index);
          }} onKeyDown={e_1 => {
            if (e_1.key === "Enter" || e_1.key === " ") {
              e_1.preventDefault();
              e_1.stopPropagation();
              goToIndex(index);
            }
          }} aria-label={`Go to slide ${index + 1}`} />;
          $[7] = currentIndex;
          $[8] = goToIndex;
          $[9] = t6;
        } else {
          t6 = $[9];
        }
        t5 = media.map(t6);
        $[3] = currentIndex;
        $[4] = goToIndex;
        $[5] = media;
        $[6] = t5;
      } else {
        t5 = $[6];
      }
      t4 = t5;
      break bb0;
    }
    let t5;
    if ($[10] !== center || $[11] !== currentIndex || $[12] !== goToIndex || $[13] !== maxVisibleDots || $[14] !== totalMedia) {
      let t6;
      if ($[16] !== center || $[17] !== currentIndex || $[18] !== goToIndex || $[19] !== totalMedia) {
        t6 = (__0, i) => {
          const dotIndex = (currentIndex - center + i + totalMedia) % totalMedia;
          const distanceFromCenter = Math.abs(i - center);
          return <div key={dotIndex} role="button" tabIndex={0} className={cn("rounded-full transition-all duration-300 cursor-pointer outline-none", distanceFromCenter === 0 ? "w-3 h-3 bg-white" : distanceFromCenter === 1 ? "w-2.5 h-2.5 bg-white/80" : distanceFromCenter === 2 ? "w-2 h-2 bg-white/60" : "w-1.5 h-1.5 bg-white/40")} onMouseDown={_temp2} onClick={e_3 => {
            e_3.preventDefault();
            e_3.stopPropagation();
            e_3.nativeEvent.stopImmediatePropagation();
            goToIndex(dotIndex);
          }} onKeyDown={e_4 => {
            if (e_4.key === "Enter" || e_4.key === " ") {
              e_4.preventDefault();
              e_4.stopPropagation();
              goToIndex(dotIndex);
            }
          }} aria-label={`Go to slide ${dotIndex + 1}`} />;
        };
        $[16] = center;
        $[17] = currentIndex;
        $[18] = goToIndex;
        $[19] = totalMedia;
        $[20] = t6;
      } else {
        t6 = $[20];
      }
      t5 = Array.from({
        length: maxVisibleDots
      }, t6);
      $[10] = center;
      $[11] = currentIndex;
      $[12] = goToIndex;
      $[13] = maxVisibleDots;
      $[14] = totalMedia;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = t5;
  }
  let t5;
  if ($[21] !== t4) {
    t5 = <div className="flex items-center space-x-1 transition-transform duration-300">{t4}</div>;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t2 || $[24] !== t5) {
    t6 = <div className={t2} style={t3}>{t5}</div>;
    $[23] = t2;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}
function _temp2(e_2) {
  e_2.preventDefault();
  e_2.stopPropagation();
}
function _temp(e) {
  e.preventDefault();
  e.stopPropagation();
}